import React from "react";

const PaymentAddedSuccessfully = ({
  id,
  isPaymentAddedSuccessfullyOpen,
  closePaymentAddedSuccessfully,
}) => {
  return (
    <>
      <div
        id={id}
        className={`${
          isPaymentAddedSuccessfullyOpen ? "flex" : "hidden"
        } flex items-center justify-center fixed inset-0 z-50 overflow-auto bg-gray-800 bg-opacity-50`}
      >
        <div className="flex items-center justify-center w-full">
          <div className="relative bg-white shadow-lg rounded-sm w-[90%] max-w-[42%] mx-auto">
            <div className="mb-5 mx-auto items-center justify-center">
              <div className="w-full flex flex-col items-center mt-5">
                <svg
                  width="53"
                  height="53"
                  viewBox="0 0 53 53"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="53" height="53" rx="26.5" fill="#8ED6A8" />
                  <path
                    d="M11 32L20.7544 38.7761L39.43 17.9347"
                    stroke="#005C53"
                    stroke-width="3"
                    stroke-linecap="round"
                  />
                </svg>

                <p className="items-center text-center font-[600] text-[16px] mt-5">
                  Payment Added
                </p>
                <p className="items-center text-center font-[400] text-[14px] text-[#4A4747]">
                  Payment has been added successfully
                </p>

                <button
                  onClick={closePaymentAddedSuccessfully}
                  className="text-[#FFFFFF] bg-[#005C53] w-[404px] h-12 rounded-lg mt-10"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentAddedSuccessfully;
